import { Component, forwardRef, Renderer2, ViewChild, Input, OnInit,OnChanges, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { EmployeeService } from '../../../service/employee/employee.service';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AutocompleteEmployeeComponent),
  multi: true,
};

@Component({
  selector: 'app-autocomplete-employee',
  templateUrl: './autocomplete-employee.component.html',
  styleUrls: ['./autocomplete-employee.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})
export class AutocompleteEmployeeComponent implements ControlValueAccessor, OnInit,OnChanges {
    @Input() employeeId: number;
    @Input() employeePosition: string;
    @Output() onMyChange = new EventEmitter();
    @Input() disabled: boolean;
    @Input() placeholder: string;
    @Input() activated_employee: boolean;

    @ViewChild('input') textarea;

    public employeesOptions: any[];

    public onChange;
    public onTouched;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public filters: {key: string, value: string}[];

    public sel: any;

    public modViewInformationEmployeeDialog: boolean;

    constructor(
        private renderer: Renderer2,
        public employeeService: EmployeeService
    ) {
        this.page = 1;
        this.per_page = 10;
        this.modViewInformationEmployeeDialog = false;
    }

    public ngOnInit() {
        
    }
    ngOnChanges(){
        //this.ngOnInit();
        this.query = undefined;
        this.filters = [];
        if (this.activated_employee) {
            this.filters.push({key: 'activated-lk', value: '1'});
        }
        
        if (this.employeePosition) {
            this.filters.push({key: 'employee_position_id-in', value: this.employeePosition});
        }
        if (!this.placeholder) {
            this.placeholder = 'employee';
        }
        if (this.employeeId) {
            this.filters.push({key: 'id-lk', value: String(this.employeeId)});
            this.getEmployees(this.query);
        }
        
    }
    writeValue(value: any ) {
        const div = this.textarea.nativeElement;
        // this.renderer.setProperty(div, 'textContent', value);
    }

    registerOnChange(fn: any ) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any ) {
        this.onTouched = fn;
    }

    // setDisabledState(isDisabled: boolean ) {
    //     const div = this.textarea.nativeElement;
    //     const action = isDisabled ? 'addClass' : 'removeClass';
    //     this.renderer[action](div, 'disabled');
    // }

    setDisabledState(isDisabled: boolean ) {
        this.disabled = isDisabled;
    }

    public change($event) {
        if (this.sel.id || this.sel == "") {
            this.onMyChange.emit(this.sel);
            this.onChange(this.sel);
            this.onTouched(this.sel);
        }
    }

    public loadEmployeesLazy(event) {
        // this.getEmployees(event.query);
        var str=event.query;
        var res = str.replace(/\s/g, "%");
        this.filters.push({key: 'activated-lk', value: '1'});
        this.getEmployees(res);
    }

    getEmployees(query?: string) {
        this.employeeService.getEmployee(this.page, this.per_page, this.sort, query, this.filters).toPromise().then(
            response => {
                this.employeesOptions = response.json().data;
                if (this.employeeId) {
                    this.employeeId = undefined;
                    if (this.employeesOptions.length > 0) {
                        this.sel = this.employeesOptions[0];
                        this.change(null);
                    }
                    this.filters = [];
                    this.filters.push({key: 'activated-lk', value: '1'});
                    if (this.employeePosition) {
                        this.filters.push({key: 'employee_position_id-in', value: this.employeePosition});
                    }
                }

                // if (response.json().meta.total > response.json().meta.total_filtered) {
                //     this.totalRecords = response.json().meta.total_filtered;
                // } else {
                //     this.totalRecords = response.json().meta.total;
                // }

                // this.employeesOptions = [];
                // employees.forEach(element => {
                //     if (this.employeeId === element.id) {
                //         this.employeesOptions.push({id: element.id, name: element.name, selected: true, company: element.company});
                //     } else {
                //         this.employeesOptions.push({id: element.id, name: element.name, selected: false, company: element.company});
                //     }
                // });
            },
            error => {
                this.employeesOptions = [];
                this.employeesOptions.push({id: '', name: 'Error'});
            }
        );
    }

    public showInformationEmployeeDialog() {
        this.modViewInformationEmployeeDialog = true;
    }
}


// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/employees/autocomplete-employee/autocomplete-employee.component.ts